import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

const baseUrl = `${API_URL}/production-transfers`;

export default {
  getAll(params = null) {
    const queryString = params ? `?${new URLSearchParams(params).toString()}` : '';
    return axios.get(`${baseUrl}${queryString}`, { headers: authHeader() });
  },

  getData(id) {
    return axios.get(`${baseUrl}/${id}`, { headers: authHeader() });
  },

  createData(data) {
    return axios.post(baseUrl, data, { headers: authHeader() });
  },

  updateData(id, data) {
    return axios.put(`${baseUrl}/${id}`, data, { headers: authHeader() });
  },

  deleteData(id) {
    return axios.delete(`${baseUrl}/${id}`, { headers: authHeader() });
  },

  getSoldProductsByDate(date) {
    return axios.get(`${baseUrl}/sold-products-by-date`, {
      params: { date },
      headers: authHeader()
    });
  },

  updateDetail(transferId, detailId, data) {
    return axios.put(`${baseUrl}/${transferId}/details/${detailId}`, data, { headers: authHeader() });
  },
};

